import {
  Box,
  PDF_BORDER,
  ReportPage,
  ReportTable,
  ReportTableTextCell,
} from '@/components';
import { ReportBatchTargetLabelModifier } from '@/features/mold/models';
import type { OrganizingTableFormat4Props } from '@/features/mold/utils/pdf/pdf-components-props';
import { useLocaledAmount } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const OrganizingTableFormat4: FC<OrganizingTableFormat4Props> = ({
  header,
  body,
  footer,
  dateByCreated,
  paperSize,
  fiscalYear,
}) => {
  const { unit } = useLocaledAmount();
  const { t } = useTranslation();

  return (
    <ReportPage
      title={{
        text: ReportBatchTargetLabelModifier['rs-report4'],
        variant: 'footnote',
      }}
      layout={{
        paperSize,
        orientation: 'landscape',
      }}
      headerStyle={{ gap: 16 }}
      caption={{ unit }}
      dateByCreated={dateByCreated}
    >
      <ReportTable
        header={header}
        data={body}
        footer={footer}
        defaultBorderStyle={PDF_BORDER.THIN}
        tableWidth="100%"
        borderColor="secondary"
      />
      <Box marginTop={4}>
        <ReportTableTextCell
          textStyle={{ lineHeight: 1.3, paddingBottom: 0 }}
          text={t('report-organizing-table-format4-footnote1', {
            year: fiscalYear - 1,
          })}
        />
        <ReportTableTextCell
          textStyle={{ lineHeight: 1.3, paddingTop: 0 }}
          text={t('report-organizing-table-format4-footnote2')}
        />
        <ReportTableTextCell
          textStyle={{ lineHeight: 1.3, paddingTop: 0 }}
          text={t('report-organizing-table-format4-footnote3')}
        />
        <ReportTableTextCell
          textStyle={{ lineHeight: 1.3, paddingTop: 0 }}
          text={t('report-organizing-table-format4-footnote4', {
            year: fiscalYear + 1,
          })}
        />
      </Box>
    </ReportPage>
  );
};
